<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelPais"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    :loading="isLoading"
    label="nome"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
  >
    <template slot="singleLabel" slot-scope="{ option }">
      <div class="flag-option">
        <flag v-if="option.iso2" :iso="option.iso2" :squared="false" />
        <span :class="option.iso2 ? 'flag-text' : 'text-secondary'">{{ option.nome }}</span>
      </div>
    </template>
    <template slot="option" slot-scope="{ option }">
      <div class="flag-option">
        <flag :iso="option.iso2" :squared="false" />
        <span class="flag-text">{{ option.nome }}</span>
      </div>
    </template>
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado.') }}</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado.') }}</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: ['nameField', 'isRequired', 'isDisabled', 'emptyLabel', 'includeAll', 'customKey'],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'pais', null);
        return;
      }
      this.$emit('selectChange', 'pais', e);
    },
    labelPais({ nome }) {
      return `${nome}`;
    },
    setValue(value) {
      if (value) {
        this.selected = this.customKey
          ? this.options.find((option) => option[this.customKey] === value)
          : this.options.find((option) => option.id === value.id);
      } else {
        this.selected = this.options.find((option) => option.id === null);
      }
      this.$emit('input', this.selected);
    },
    setOptions() {
      this.isLoading = true;
      this.$atenaList
        .getPaises({ order: 'nome' })
        .then((res) => {
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    }
  },
  created() {
    this.setOptions();
  },
  watch: {
    nameField: function (value) {
      this.setValue(value);
    }
  }
};
</script>

<style lang="scss" scoped></style>
